module.exports = __webpack_public_path__ + "static/img/banner-1.6ef797b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/advantage/banner-1.png
// module id = K7LG
// module chunks = 1